import React from 'react';
import { Grid, Box, Typography } from "@mui/material";
import { styles } from "./styles";
import { Colors } from "assets/colors";

interface KpiCardProps {
  label: string;
  label1: string;
  label2: string;
  value: string | number;
  value1: string | number;
  value2: string | number;
  icon?: any;
}

const KpiCard: React.FC<KpiCardProps> = ({label,label1,label2, value,value1,value2, icon}) => {

  return (
    <Grid item xs={12} sx={styles.container} height="180px">
      <Box sx={styles.header}>
        <Typography>{label}</Typography>
        {icon && <img src={icon} alt="" />}
      </Box>
      <Box sx={{display:'flex'}}>
      <h1>{value}</h1>
      </Box>
    
     <Grid container>
      <Grid item xs={12} sx={{ display: 'flex' }}>
        <Grid xs={3} lg={6} xl={12}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "start", color: Colors.GrayText, fontSize: "1.1rem" }}>
          
        <Typography>{label1}</Typography>
          <h3 style={{ color: '#3F4344',marginLeft:'10px' }}>{value1}</h3>
          </Box>
        </Grid> 
        <Grid xs={3} lg={6} xl={12}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "start", color: Colors.GrayText, fontSize: "1.1rem" }}>
        <Typography>{label2}</Typography>
          <h3 style={{ color: '#3F4344',marginLeft:'10px' }}>{value2}</h3>
          </Box> 
          </Grid>
        </Grid> 
        </Grid>
        
         
  </Grid>
    
  )
}

export default KpiCard;